import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {AuthenticationService} from '../services/authentication.service';
import {AuthenticationResponseModel} from '../model/authentication-response.model';

@Component({
  selector: 'app-patient-auto-login',
  templateUrl: 'patient-auto-login.component.html'
})
export class PatientAutoLoginComponent implements OnInit {
  public outStr = 'init load';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
  ){}

  ngOnInit() {
    const token: string = this.route.snapshot.paramMap.get('token')!;
    const formId: string = this.route.snapshot.paramMap.get('formId')!;

    if (token && formId) {
      this.outStr += ' ' + token + ' ' + formId;
      this.authService.autoLoginPatient(token).subscribe((res: AuthenticationResponseModel) => {
        if (res.isSuccess) {
          this.router.navigateByUrl('/patientformviewer/' + formId);
          console.log('auto login success');
          this.outStr += ' - success';
        }
      });
    }
  }
}
